import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Transcripts from './Transcripts';

const mapStateToProps = state => ({
    supportedLanguages: state.i18n.supportedLanguages,
});

export default connect(mapStateToProps)(withRouter(Transcripts));
